import React, { useContext } from "react";
import { Box, IconButton, Slide, Snackbar, Typography } from "@mui/material";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import CloseIcon from "@mui/icons-material/Close";
import { ThemeContext } from "../../theme/ThemeContext";

function SlideDownTransition(props) {
  return <Slide {...props} direction="down" />;
}

export default function FrontDeskTeamsAlert({
  open,
  visitorName,
  onClose,
  onClick,
}) {
  const { darkMode } = useContext(ThemeContext);
  const accentColor = process.env.REACT_APP_BG_HEADER_LOGO || "#226BAB";

  return (
    <Snackbar
      open={!!open}
      autoHideDuration={7000}
      onClose={onClose}
      TransitionComponent={SlideDownTransition}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ marginTop: "68px" }}
    >
      <Box
        onClick={onClick}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
          width: "340px",
          padding: "12px 14px",
          borderRadius: "10px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
          backgroundColor: darkMode ? "#0E2A41" : "#fff",
          color: darkMode ? "#fff" : "#1a1a1a",
          borderLeft: `4px solid ${accentColor}`,
          cursor: onClick ? "pointer" : "default",
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            backgroundColor: accentColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <PersonAddAlt1Icon sx={{ color: "#fff", fontSize: 20 }} />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
            New Visitor
          </Typography>
          <Typography
            sx={{
              fontSize: "13px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {visitorName || "A new visitor"} was pre-registered
          </Typography>
        </Box>

        <IconButton
          size="small"
          onClick={(event) => {
            event.stopPropagation();
            onClose();
          }}
          sx={{ color: darkMode ? "#fff" : "#666", marginTop: "-4px" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Snackbar>
  );
}
